<template>
  <div>
    <template v-if="mediaLgMatches">
      <PricingTariffsSlider v-bind="pricingTariffsOptions" />
    </template>
    <template v-else>
      <PricingTariffsList v-bind="pricingTariffsOptions" />
    </template>
  </div>
</template>

<script>
import { BREAKPOINTS } from '~scripts/core/breakpoints';
import PricingTariffsList from './PricingTariffsList.vue';
import PricingTariffsSlider from './PricingTariffsSlider.vue';

export default {
  name: 'PricingTariffs',
  components: { PricingTariffsList, PricingTariffsSlider },
  props: {
    currency: {
      type: String,
      default: 'rub',
    },
  },
  data() {
    return {
      mediaLgMatches: false,
    };
  },
  computed: {
    region() {
      return window.region;
    },
    lang() {
      return this.region === 'ai' ? 'en' : 'ru';
    },
    breakpoints() {
      return BREAKPOINTS;
    },
    mediaLg() {
      return window.matchMedia(`(min-width: ${this.breakpoints.lgMin})`);
    },
    pricingTariffsOptions() {
      if (this.region === 'kz') {
        return { currency: 'kzt' };
      } else if (this.region === 'uz') {
        return { currency: 'uzs' };
      } else if (this.region === 'ai') {
        return { currency: 'eur', lang: 'en' };
      }
      return { currency: this.currency };
    },
  },
  mounted() {
    this.handleMediaLgMatchesChange();
    this.mediaLg.addEventListener('change', this.handleMediaLgMatchesChange, { passive: true });
  },
  beforeDestroy() {
    this.mediaLg.removeEventListener('change', this.handleMediaLgMatchesChange);
  },
  methods: {
    handleMediaLgMatchesChange() {
      this.mediaLgMatches = this.mediaLg.matches;
    },
    handleTab(current) {
      this.$emit('tab', current);
    },
  },
};
</script>
